import { useState } from 'react'
import { RegisterOptions, useFormContext } from 'react-hook-form'

import InputLabel from '@atoms/InputLabel'
import ArrowLeft from '@icons/ArrowLeft'

import * as style from './style.module.sass'

type SelectorItem = {
  value: string
  label: string
}

type SelectorProps = {
  name: string
  selectorItems: SelectorItem[]
  label?: string
  registerOptions?: RegisterOptions
  placeholder?: string
  errorMessage?: string
  className?: string
}
const Selector = ({
  name,
  selectorItems,
  label,
  registerOptions = {},
  placeholder,
  errorMessage,
  className,
}: SelectorProps) => {
  const { register, watch } = useFormContext()
  const currentValue = watch(name)
  const selected = currentValue !== null && currentValue !== undefined

  const [open, setOpen] = useState(false)

  return (
    <div className={`${style.selector} ${className}`}>
      {label !== undefined && (
        <InputLabel
          label={label}
          required={registerOptions.required === true}
          design="large"
        />
      )}
      <button
        className={style.current}
        onClick={() => setOpen(!open)}
        data-selected={selected}
        type="button"
        data-error={errorMessage !== undefined}
      >
        {selected
          ? selectorItems.find(item => item.value === currentValue)?.label
          : placeholder}
      </button>
      <div className={style.icon} data-open={open}>
        <ArrowLeft />
      </div>
      <div
        className={style.items}
        data-open={open}
        style={{
          height: `${(13 + 32) * selectorItems.length + 24}px`,
        }}
      >
        {selectorItems.map(item => (
          <label
            key={item.value}
            className={style.item}
            onClick={() => setOpen(false)}
          >
            <input
              type="radio"
              value={item.value}
              {...register(name, registerOptions)}
            />
            {item.label}
          </label>
        ))}
      </div>
      {errorMessage !== undefined && (
        <div className={style.errorMessage}>{errorMessage}</div>
      )}
    </div>
  )
}

export default Selector
